export default {
  'Extract audio': 'Audio extrahieren',
  'Mute': 'Stumm',
  'Split video and audio': 'Video und Audio teilen',
}